// extracted by mini-css-extract-plugin
module.exports = {"detail_section":"position-finder-detail_detail_section__1I33M"};